
export const StatusCell = ({ value, t }) => {
  switch (value) {
    case 'active':
      return <div
        className="bg-green text-white px-2 text-sm text-center ml-2 w-100"
        style={{ borderRadius: "12px", display: 'flex', justifyContent: 'center' }}
      >
        {t('active')}
      </div >
    case 'finished':
      return <div
        className="bg-orange text-white px-2 text-sm text-center ml-2 w-100"
        style={{ borderRadius: "12px", display: 'flex', justifyContent: 'center', }}
      >
        {t('finished')}
      </div >
    case 'inactive':
    case 'deleted':
      return <div
        className="bg-red text-white px-2 text-sm text-center ml-2 w-100"
        style={{ borderRadius: "12px", display: 'flex', justifyContent: 'center' }}
      >
        {t(value)}
      </div >
    default:
      return <div
        className="bg-orange text-white px-2 text-sm text-center ml-2 w-100"
        style={{ borderRadius: "12px", display: 'flex', justifyContent: 'center' }}
      >
        {t('pending')}
      </div>
  }
}